
const Helper =  {

  toXPos: function(fkValue,w) {
    if(fkValue===0) return 0;
		return Math.round((fkValue / 100) * w);
  },
  toXPosFloat: function(fkValue,w) {
    if(fkValue===0) return 0;
		return ((fkValue / 100) * w);
  },
	toXPercent: function(fkValue,w) {
    if(fkValue===0) return 0;
		return ((fkValue * 100) / w);
	},
	toYPos: function(fkValue,h) {
    if(fkValue===0) return 0;
		return Math.round((fkValue / 100.0) * h);
	},
  toYPosFloat: function(fkValue,h) {
    if(fkValue===0) return 0;
		return ((fkValue / 100.0) * h);
	},

	toYPercent: function(fkValue,h) {
    if(fkValue===0) return 0;
		return  ((fkValue * 100.0) / h);
	},
	toScaleValue: function(fkValue,h){
    if(fkValue===0) return 0;
    return Math.round((fkValue / 100.0) * h);
	},
};
export default Helper;
